
const STORAGE_KEY = 'banners:dismissed';

type DismissedMap = Record<string, string>;

function read(): DismissedMap {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    return parsed && typeof parsed === 'object' ? (parsed as DismissedMap) : {};
  } catch {
    return {};
  }
}

function write(map: DismissedMap): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
  }
}

export function isDismissed(id: string, updatedAt: string): boolean {
  return read()[id] === updatedAt;
}

export function markDismissed(id: string, updatedAt: string): void {
  write({ ...read(), [id]: updatedAt });
}

export function pruneDismissed(liveIds: string[]): void {
  const map = read();
  const live = new Set(liveIds);
  let changed = false;
  for (const id of Object.keys(map)) {
    if (!live.has(id)) {
      delete map[id];
      changed = true;
    }
  }
  if (changed) write(map);
}
